<template>
  <container
    :isModal="params.isSearch"
    @close-modal="cancelSelection()"
    :loading="!stateReady"
  >
    <template v-slot:header>
      <h3>Consulta de Planilha de Trechos</h3>
    </template>
    <template v-slot:body>
      <div>
        <form @submit.prevent="submitSearch">
          <entity-selector-cliente
            :cliente="cliente"
            :canEdit="!cliente"
            :idClienteFiltered="filter.idCliente"
            @confirm-selection="confirmSelectionCliente"
            :parentLoading="stateLoading || showEdit"
          />
          <fieldset :disabled="stateLoading || showEdit">
            <div class="p-formgrid p-grid">
              <div class="p-field p-fluid p-col-12 p-md-12 p-lg-4">
                <input-with-label label="Nome" v-slot="l">
                  <InputText
                    v-model="filter.nome"
                    :id="l.id"
                    :required="l.required"
                    v-focus
                  />
                </input-with-label>
              </div>
              <div class="p-field p-fluid p-col-12 p-md-12 p-lg-4">
                <entity-selector-orgao-aet
                  :idOrgao="filter.idOrgao"
                  @after-set-orgao="afterSetOrgao"
                  :readOnly="
                    stateLoading ||
                      showEdit ||
                      !!(preFilter && preFilter.idOrgao)
                  "
                />
              </div>
              <div class="p-field p-fluid p-col-12 p-md-12 p-lg-4 p-pt-3">
                <input-with-label
                  label="Arquivado"
                  v-slot="l"
                  :floatLabel="false"
                >
                  <InputSwitch
                    v-model="filter.arquivado"
                    :id="l.id"
                    :required="l.required"
                  />
                </input-with-label>
              </div>

              <div class="p-col-12">
                <button-group>
                  <Button
                    type="submit"
                    class="p-button-rounded"
                    label="Buscar"
                  />
                  <Button
                    label="Limpar"
                    class="p-button-rounded p-button-text"
                    @click="clearFilter()"
                  />
                </button-group>
              </div>
            </div>
          </fieldset>
        </form>
      </div>
      <search-result
        :showSelector="params.isSearch"
        :results="results"
        :selected="params.selected"
        :multiple="params.isMultiple"
        :keyParam="'idPlanilhaTrechos'"
        :loading="stateLoading"
        :showClient="true"
        @after-page-change="afterPageChange"
        @confirm-selection="confirmSelection"
      >
        <template v-slot:columns>
          <Column
            field="idOrgao"
            header="Órgão"
            headerClass="p-header-center"
            style="width: 6rem; text-align: center"
          >
            <template #body="slotProps">
              <orgao-aet-img :idOrgao="slotProps.data.idOrgao" />
            </template>
          </Column>
          <Column field="nome" header="Nome">
            <template #body="slotProps">
              <span v-text="getNome(slotProps.data)" />
            </template>
          </Column>
          <Column :exportable="false" style="width: 10rem; text-align: right">
            <template #body="slotProps">
              <button-group>
                <Button
                  icon="pi pi-pencil"
                  class="p-button-rounded p-button-success"
                  v-if="amIAllowed('view', slotProps.data.permissionInfo)"
                  @click="openEntity(slotProps.data.idPlanilhaTrechos)"
                  @click.middle.prevent.stop="
                    openEntity(slotProps.data.idPlanilhaTrechos, true)
                  "
                />

                <Button
                  icon="fa-solid fa-circle-check"
                  class="p-button-rounded"
                  v-if="
                    !params.isSearch &&
                      amIAllowed('set_default', slotProps.data.permissionInfo)
                  "
                  @click="setDefaultEntity(slotProps.data)"
                  :disabled="
                    amIBlocked('set_default', slotProps.data.permissionInfo)
                  "
                  v-title="
                    [
                      'Definir como Planilha Padrão',
                      amIBlocked('set_default', slotProps.data.permissionInfo)
                        ?.info
                    ]
                      .filter((e) => e)
                      .join(' - ')
                  "
                />
                <Button
                  icon="fas fa-folder-minus"
                  class="p-button-rounded p-button-danger"
                  v-if="
                    !params.isSearch &&
                      amIAllowed('shelve', slotProps.data.permissionInfo)
                  "
                  @click="shelveEntity(slotProps.data)"
                  :disabled="
                    amIBlocked('shelve', slotProps.data.permissionInfo)
                  "
                  v-title="
                    [
                      'Arquivar',
                      amIBlocked('shelve', slotProps.data.permissionInfo)?.info
                    ]
                      .filter((e) => e)
                      .join(' - ')
                  "
                />
                <Button
                  icon="fas fa-folder-plus"
                  class="p-button-rounded p-button-secondary"
                  v-if="
                    !params.isSearch &&
                      amIAllowed('unshelve', slotProps.data.permissionInfo)
                  "
                  @click="unshelveEntity(slotProps.data)"
                  :disabled="
                    amIBlocked('unshelve', slotProps.data.permissionInfo)
                  "
                  v-title="
                    [
                      'Desarquivar',
                      amIBlocked('unshelve', slotProps.data.permissionInfo)
                        ?.info
                    ]
                      .filter((e) => e)
                      .join(' - ')
                  "
                />
              </button-group>
            </template>
          </Column>
        </template>
        <template v-slot:actions>
          <Button
            label="Novo"
            :class="
              'p-button-rounded' + (params.isSearch ? ' p-button-text' : '')
            "
            v-if="amIAllowed('create', 'trechos-planilha')"
            @click="newEntity()"
          />
        </template>
      </search-result>
      <div class="register" v-if="showEdit">
        <cadastro-planilhaTrechos
          :planilhaTrechos="planilhaTrechos"
          @after-register-screen-closed="afterRegisterScreenClosed"
          @after-save-new-entity="afterSaveNewEntity"
          @generate-copy="generateCopy"
          :parentLoading="stateLoading"
          :key="keyRegister"
          :cliente="cliente"
        />
      </div>
    </template>
  </container>
</template>

<script lang="ts">
import CadastroPlanilhaTrechos from "./CadastroPlanilhaTrechos.vue";
import EntitySelectorOrgaoAet from "../common/EntitySelectorOrgaoAet.vue";
import { PaginationResult, defaultResults } from "../../pagination";
import { useAuth, PermissionPayload } from "../../modules/auth";
import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  onMounted,
  PropType,
  Ref,
  watch
} from "vue";
import { RouteLocationNormalizedLoaded, useRouter } from "vue-router";
import {
  PlanilhaTrechosPayload,
  PlanilhaTrechosFilterPayload,
  usePlanilhaTrechosService
} from "../../modules/business/trecho/planilhaTrechosBusiness";
import { clearObject, copyObject } from "../../modules/utils";
import {
  ClientePayload,
  useClienteService,
  useClienteLogadoService
} from "../../modules/business/cliente/clienteBusiness";
import {
  indexesOfElement,
  addSetElement,
  toggleElement,
  format
} from "../../modules/utils";
import { focusOnLastElement } from "../../modules/globalAppProperties";
import { useConfirm } from "../../modules/message";
import EntitySelectorCliente from "../cliente/EntitySelectorCliente.vue";

interface PlanilhaTrechosComponentParams {
  isSearch: boolean;
  selected: Array<PlanilhaTrechosPayload>;
  isNew?: boolean;
  isMultiple?: boolean;
  idPlanilhaTrechos?: number;
  idPlanilhaTrechosCopy?: number;
  preFilter?: PlanilhaTrechosFilterPayload;
}

interface PlanilhaTrechosState {
  planilhaTrechos: PlanilhaTrechosPayload | null;
  showEdit: boolean;
  results: PaginationResult<PlanilhaTrechosPayload>;
  filter: PlanilhaTrechosFilterPayload;
  page: number;
  stateReady: boolean;
  params: PlanilhaTrechosComponentParams;
  loadings: Array<Ref<boolean>>;
  stateId: string;
}

export default defineComponent({
  setup(props, { emit }) {
    const router = useRouter();

    const state = reactive<PlanilhaTrechosState>({
      planilhaTrechos: null,
      showEdit: false,
      stateReady: false,
      filter: usePlanilhaTrechosService().safeFilterPlanilhaTrecho(),
      page: 0,
      results: defaultResults(),
      loadings: [],
      params: {
        isSearch: props.isSearch,
        isNew: props.isNew,
        idPlanilhaTrechos: props.idPlanilhaTrechos,
        idPlanilhaTrechosCopy: props.idPlanilhaTrechosCopy,
        selected: props.selected ?? [],
        isMultiple: props.isMultiple,
        preFilter: props.preFilter
      },
      stateId:
        "state-" +
        Math.random()
          .toString(36)
          .substring(2)
    });

    copyObject(clearObject(props.preFilter), state.filter);

    const amIAllowed = (
      authority: string,
      permissionInfo?: PermissionPayload | string | null
    ) => {
      return useAuth().amIAllowed(authority, permissionInfo);
    };

    const amIBlocked = (
      authority: string,
      permissionInfo?: PermissionPayload | string | null
    ) => {
      return useAuth().amIBlocked(authority, permissionInfo);
    };

    const getNome = (e?: PlanilhaTrechosPayload) => {
      return usePlanilhaTrechosService().getNomePlanilhaTrechos(e);
    };

    const stateLoading = computed(() => {
      return state.loadings.length !== 0;
    });

    const keyRegister = computed(() => {
      return state.showEdit
        ? state.planilhaTrechos?.idPlanilhaTrechos
          ? state.planilhaTrechos?.idPlanilhaTrechos
          : "new-" +
            Math.random()
              .toString(36)
              .substring(2)
        : null;
    });

    const executeSearch = () => {
      const {
        data,
        loading,
        searchPlanilhaTrechos
      } = usePlanilhaTrechosService();
      state.loadings.push(loading);
      return searchPlanilhaTrechos(state.filter, state.page)
        .then(() => {
          state.results = data.value;
          state.page = state.results.number;
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        })
        .catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
    };

    const submitSearch = () => {
      state.page = 0;
      state.results = defaultResults();
      return executeSearch();
    };

    const getParamsRouteEdit = (idPlanilhaTrechos: number) => {
      return {
        name: "trechos-planilha-edit",
        params: { idPlanilhaTrechos: idPlanilhaTrechos + "" }
      };
    };

    const processViewRoute = (
      route: Partial<RouteLocationNormalizedLoaded>
    ) => {
      if (
        route.name == "trechos-planilha-new" ||
        route.name == "trechos-planilha-edit" ||
        route.name == "trechos-planilha-copy"
      ) {
        const {
          newPlanilhaTrechos,
          getPlanilhaTrechos,
          copyPlanilhaTrechos,
          data,
          loading
        } = usePlanilhaTrechosService();
        let p: Promise<void>;
        state.loadings.push(loading);
        if (route.name == "trechos-planilha-new") {
          p = newPlanilhaTrechos(props.cliente?.idCliente);
        } else if (route.name == "trechos-planilha-edit") {
          let id: number | undefined;
          if (route.params && route.params.idPlanilhaTrechos) {
            id = Array.isArray(route.params.idPlanilhaTrechos)
              ? +route.params.idPlanilhaTrechos[0]
              : +route.params.idPlanilhaTrechos;
          }
          if (!id) {
            throw "illegal id";
          }
          p = getPlanilhaTrechos(id);
        } else {
          let id: number | undefined;
          if (route.params && route.params.idPlanilhaTrechosCopy) {
            id = Array.isArray(route.params.idPlanilhaTrechosCopy)
              ? +route.params.idPlanilhaTrechosCopy[0]
              : +route.params.idPlanilhaTrechosCopy;
          }
          if (!id) {
            throw "illegal id";
          }
          p = copyPlanilhaTrechos(id);
        }
        p.then(() => {
          state.planilhaTrechos = data.value;
          state.showEdit = true;
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        }).catch(() => {
          state.loadings.splice(state.loadings.indexOf(loading), 1);
        });
      } else {
        state.showEdit = false;
        state.planilhaTrechos = null;
        executeSearch();
      }
    };

    const setDefaultEntity = (planilhaTrechos: PlanilhaTrechosPayload) => {
      useConfirm().require({
        message:
          "Deseja alterar a Planilha " +
          getNome(planilhaTrechos) +
          " como Padrão?",
        header: "Atenção",
        icon: "pi pi-info-circle",
        acceptClass: "p-button-danger",
        accept: () => {
          if (planilhaTrechos && planilhaTrechos.idPlanilhaTrechos) {
            const {
              setDefaultPlanilhaTrechos,
              loading
            } = usePlanilhaTrechosService();
            state.loadings.push(loading);
            setDefaultPlanilhaTrechos(planilhaTrechos.idPlanilhaTrechos)
              .then(() => {
                executeSearch();
                state.loadings.splice(state.loadings.indexOf(loading), 1);
              })
              .catch(() => {
                state.loadings.splice(state.loadings.indexOf(loading), 1);
              });
          }
        }
      });
    };
    const shelveEntity = (planilhaTrechos: PlanilhaTrechosPayload) => {
      useConfirm().require({
        message: "Deseja arquivar a Planilha " + getNome(planilhaTrechos) + "?",
        header: "Atenção",
        icon: "pi pi-info-circle",
        acceptClass: "p-button-danger",
        accept: () => {
          if (planilhaTrechos && planilhaTrechos.idPlanilhaTrechos) {
            const {
              shelvePlanilhaTrechos,
              loading
            } = usePlanilhaTrechosService();
            state.loadings.push(loading);
            shelvePlanilhaTrechos(planilhaTrechos.idPlanilhaTrechos)
              .then(() => {
                executeSearch();
                state.loadings.splice(state.loadings.indexOf(loading), 1);
              })
              .catch(() => {
                state.loadings.splice(state.loadings.indexOf(loading), 1);
              });
          }
        }
      });
    };

    const unshelveEntity = (planilhaTrechos: PlanilhaTrechosPayload) => {
      useConfirm().require({
        message:
          "Deseja desarquivar a Planilha " + getNome(planilhaTrechos) + "?",
        header: "Atenção",
        icon: "pi pi-info-circle",
        acceptClass: "p-button-danger",
        accept: () => {
          if (planilhaTrechos && planilhaTrechos.idPlanilhaTrechos) {
            const {
              unshelvePlanilhaTrechos,
              loading
            } = usePlanilhaTrechosService();
            state.loadings.push(loading);
            unshelvePlanilhaTrechos(planilhaTrechos.idPlanilhaTrechos)
              .then(() => {
                executeSearch();
                state.loadings.splice(state.loadings.indexOf(loading), 1);
              })
              .catch(() => {
                state.loadings.splice(state.loadings.indexOf(loading), 1);
              });
          }
        }
      });
    };

    const confirmSelection = (selected: Array<PlanilhaTrechosPayload>) => {
      emit("confirm-selection", selected);
    };

    const cancelSelection = () => {
      emit("cancel-selection");
    };

    const openEntity = (
      idPlanilhaTrechos: number,
      force?: boolean,
      newTab?: boolean
    ) => {
      const routeParams = getParamsRouteEdit(idPlanilhaTrechos);
      if (newTab) {
        window.open(router.resolve(routeParams).fullPath);
      } else if (state.params.isSearch || force) {
        processViewRoute(routeParams);
      } else {
        router.push(routeParams);
      }
    };

    const newEntity = (force?: boolean) => {
      const routeParams = {
        name: "trechos-planilha-new"
      };
      if (state.params.isSearch || force) {
        processViewRoute(routeParams);
      } else {
        router.push(routeParams);
      }
    };

    const generateCopy = (idPlanilhaTrechosCopy: number, force?: boolean) => {
      const routeParams = {
        name: "trechos-planilha-copy",
        params: { idPlanilhaTrechosCopy: idPlanilhaTrechosCopy + "" }
      };
      if (state.params.isSearch || force) {
        processViewRoute(routeParams);
      } else {
        router.push(routeParams);
      }
    };

    const afterSetOrgao = (idOrgao?: number | null) => {
      state.filter.idOrgao = idOrgao;
    };

    const afterRegisterScreenClosed = (
      planilhaTrechos?: PlanilhaTrechosPayload
    ) => {
      const routeParams = {
        name: "trechos-planilha"
      };
      if (state.params.isSearch) {
        if (state.params.idPlanilhaTrechos) {
          if (planilhaTrechos && planilhaTrechos.idPlanilhaTrechos) {
            confirmSelection([planilhaTrechos]);
          } else {
            cancelSelection();
          }
        } else {
          if (
            planilhaTrechos &&
            indexesOfElement(
              state.params.selected,
              planilhaTrechos,
              (ob) => ob && ob.idPlanilhaTrechos
            ).length <= 0
          ) {
            useConfirm().require({
              message: "Deseja selecionar o registro salvo?",
              header: "Confirmação",
              icon: "pi pi-info-circle",
              accept: () => {
                toggleElement(
                  state.params.selected,
                  planilhaTrechos,
                  (ob) => ob && ob.idPlanilhaTrechos,
                  state.params.isMultiple
                );
                processViewRoute(routeParams);
              },
              reject: () => {
                processViewRoute(routeParams);
              }
            });
          } else {
            processViewRoute(routeParams);
          }
        }
      } else {
        router.push(routeParams);
      }
    };

    const afterSaveNewEntity = (idPlanilhaTrechos: number) => {
      openEntity(idPlanilhaTrechos);
    };

    const afterPageChange = (page: number) => {
      state.page = page;
      executeSearch();
    };

    const clearFilter = () => {
      state.filter = usePlanilhaTrechosService().safeFilterPlanilhaTrecho();
      state.results = defaultResults();
      copyObject(clearObject(props.preFilter), state.filter);
    };

    const getNomeCliente = (e?: ClientePayload) => {
      return (amIAllowed("view", "root-cliente")
        ? useClienteService()
        : useClienteLogadoService()
      ).getNomeCliente(e);
    };

    const confirmSelectionCliente = (c?: ClientePayload) => {
      state.filter.idCliente = c && c.idCliente ? c.idCliente : undefined;
    };

    const deveAbrirTelaCadastro =
      state.params.idPlanilhaTrechos || state.params.isNew;
    if (deveAbrirTelaCadastro) {
      if (state.params.idPlanilhaTrechos) {
        openEntity(state.params.idPlanilhaTrechos, true);
      } else if (state.params.idPlanilhaTrechosCopy) {
        generateCopy(state.params.idPlanilhaTrechosCopy, true);
      } else {
        newEntity(true);
      }
    }

    onMounted(async () => {
      if (props.cliente && props.cliente.idCliente) {
        state.filter.idCliente = props.cliente.idCliente;
      }
      state.stateReady = true;
      if (!state.params.isSearch) {
        watch([router.currentRoute], () => {
          const currRoute = router.currentRoute.value;
          processViewRoute(currRoute);
        });
      }
      if (!deveAbrirTelaCadastro) {
        submitSearch().then(() => {
          if (
            state.params.preFilter &&
            state.params.preFilter.idOrgao &&
            state.results.content.length == 1
          ) {
            const arr = [] as Array<PlanilhaTrechosPayload>;
            state.params.selected.forEach((el) => arr.push(el));
            addSetElement(
              arr,
              state.results.content[0],
              (ob) => ob && ob.idPlanilhaTrechos,
              state.params.isMultiple
            );
            confirmSelection(arr);
          } else {
            focusOnLastElement();
          }
        });
      }
    });

    return {
      submitSearch,
      executeSearch,
      openEntity,
      newEntity,
      generateCopy,
      setDefaultEntity,
      shelveEntity,
      unshelveEntity,
      confirmSelection,
      cancelSelection,
      afterRegisterScreenClosed,
      afterSaveNewEntity,
      afterPageChange,
      clearFilter,
      keyRegister,
      format,
      amIAllowed,
      amIBlocked,
      afterSetOrgao,
      getNome,
      getNomeCliente,
      getParamsRouteEdit,
      stateLoading,
      confirmSelectionCliente,
      ...toRefs(state)
    };
  },
  components: {
    CadastroPlanilhaTrechos,
    EntitySelectorOrgaoAet,
    EntitySelectorCliente
  },
  props: {
    isSearch: Boolean,
    isNew: Boolean,
    isMultiple: Boolean,
    idPlanilhaTrechos: Number,
    idPlanilhaTrechosCopy: Number,
    preFilter: Object as PropType<PlanilhaTrechosFilterPayload>,
    cliente: Object as PropType<ClientePayload>,
    selected: {
      type: Array as PropType<Array<PlanilhaTrechosPayload>>
    }
  }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
